// extracted by mini-css-extract-plugin
export var brand = "_1d-9";
export var button = "_1d-0";
export var chevron = "_1d-v";
export var chevronButton = "_1d-w";
export var content = "_1d-n";
export var danger = "_1d-g";
export var dangerOutlined = "_1d-h";
export var dark = "_1d-l";
export var darkTheme = "_1d-c";
export var extraSmall = "_1d-4";
export var fullWidth = "_1d-8";
export var ghost = "_1d-d";
export var gray = "_1d-t";
export var icon = "_1d-p";
export var iconButton = "_1d-s";
export var iconButtonBorder = "_1d-x";
export var iconButtonBorderDark = "_1d-y";
export var iconButtonBorderLight = "_1d-z";
export var iconLeft = "_1d-q";
export var iconRight = "_1d-r";
export var large = "_1d-1";
export var light = "_1d-m";
export var medium = "_1d-2";
export var micro = "_1d-5";
export var nano = "_1d-7";
export var outlined = "_1d-k";
export var pending = "_1d-a";
export var primary = "_1d-i";
export var shadow = "_1d-o";
export var small = "_1d-3";
export var solidLight = "_1d-e";
export var solidLightBrand = "_1d-f";
export var spinner = "_1d-u";
export var transparent = "_1d-j";
export var warning = "_1d-b";
export var wideNano = "_1d-6";